"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var events_1 = require("events");
var invariant_1 = __importDefault(require("invariant"));
var Socket = /** @class */ (function (_super) {
    __extends(Socket, _super);
    function Socket(_a) {
        var url = _a.url, _b = _a.is_connect_auto, is_connect_auto = _b === void 0 ? true : _b;
        var _this = _super.call(this) || this;
        _this.id = 0;
        _this.ddp = new events_1.EventEmitter();
        _this.subscriptions = {};
        invariant_1["default"](url, 'Url is required for chat Socket');
        url = url.replace(/^http/, 'ws');
        url = url.replace('/websocket', '');
        url += '/websocket';
        _this.url = url;
        _this.setupHooks();
        if (is_connect_auto)
            _this.connect();
        return _this;
    }
    Socket.prototype.setupHooks = function () {
        var _this = this;
        this.on('ping', function () { return _this.sendPayload({ msg: 'pong' }); });
        // when we get result message from method request
        this.on('result', function (data) {
            _this.ddp.emit(data.id, {
                id: data.id,
                result: data.result,
                error: data.error
            });
        });
        this.on('ready', function (data) { return _this.ddp.emit(data.subs[0], data); });
    };
    Socket.prototype.send = function (obj) {
        var id = obj.id || "" + ++this.id;
        var payload = __assign(__assign({}, obj), { id: id });
        return this.sendPayload(payload);
    };
    Socket.prototype.sendPayload = function (obj) {
        var _this = this;
        var payloadStr = JSON.stringify(obj);
        invariant_1["default"](this.connection, 'ddp#send: Connection is not opened');
        this.connection.send(payloadStr);
        return new Promise(function (resolve, reject) {
            var id = obj.id;
            if (!id)
                return resolve();
            _this.ddp.once(id, function (data) {
                // console.log('response', obj, data)
                return data.error ? reject(data.error) : resolve(__assign({ id: id }, data));
            });
        });
    };
    Socket.prototype.connect = function () {
        var _this = this;
        var connection = new WebSocket(this.url);
        connection.onopen = function () {
            _this.emit('open');
            _this.sendPayload({
                msg: 'connect',
                version: '1',
                support: ['1']
            });
        };
        connection.onclose = function (e) {
            _this.emit('disconnected', e);
        };
        connection.onerror = function (error) {
            // console.log('connection.onerror', error)
            _this.emit('error', error);
        };
        // @ts-ignore
        connection.onmessage = function (event) {
            var data = JSON.parse(event.data);
            if (!data.msg)
                return null;
            if (data.msg !== 'ping') {
                // console.log('websocket connection.onmessage', data.msg, data)
            }
            _this.emit(data.msg, data);
            if (data.collection) {
                // subscription events
                _this.emit(data.collection, data);
            }
        };
        // this.on('disconnected', e => alert(JSON.stringify(e)));
        this.connection = connection;
    };
    Socket.prototype.logout = function () {
        var _this = this;
        return this.call('logout').then(function () {
            _this.subscriptions = {};
        });
    };
    Socket.prototype.reconnect = function () {
        // console.log('call disconnect', this)
        // this.disconnect()
        // this.once('connected', () => { //todo may be we dont need this anymore
        //   Object.keys(this.subscriptions).forEach((key) => {
        //     const { name, params } = this.subscriptions[key]
        //     this.subscriptions[key].unsubscribe()
        //     this.subscribe(name, params)
        //   })
        // })
        if (this.connection) {
            if ([this.connection.OPEN, this.connection.CONNECTING].includes(this.connection.readyState))
                return;
        }
        this.connect();
    };
    Socket.prototype.call = function (method) {
        var params = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            params[_i - 1] = arguments[_i];
        }
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.send({
                            msg: 'method',
                            method: method,
                            params: params
                        })];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, data.result];
                }
            });
        });
    };
    /*
      stream-notify-logged => Deleted user, https://rocket.chat/docs/developer-guides/realtime-api/subscriptions/stream-notify-logged/
      stream-notify-room => delete message, typing => https://rocket.chat/docs/developer-guides/realtime-api/subscriptions/stream-notify-room/
      stream-room-messages =>
  
  
     Example:  chat.ddp.subscribe('stream-notify-user', `${userId}/notification`, false)
   */
    Socket.prototype.subscribe = function (name, event, isReceiveEveryTime) {
        if (isReceiveEveryTime === void 0) { isReceiveEveryTime = false; }
        return __awaiter(this, void 0, void 0, function () {
            var id, args;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.send({
                            msg: 'sub',
                            name: name,
                            params: [event, isReceiveEveryTime]
                        })];
                    case 1:
                        id = (_a.sent()).id;
                        args = {
                            name: name,
                            event: event,
                            unsubscribe: function () { return _this.unsubscribe(id); }
                        };
                        this.subscriptions[id] = args;
                        return [2 /*return*/, args];
                }
            });
        });
    };
    // todo sometimes we receive nosub event
    // I found article about it, and looks like it is RocketChat bug
    Socket.prototype.unsubscribe = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        invariant_1["default"](this.subscriptions[id], 'RocketChat: subscription with this id is not exists.');
                        return [4 /*yield*/, this.send({
                                msg: 'unsub',
                                id: id,
                                params: []
                            })
                            // todo what real response?
                            // console.log('unsubscrie', response)
                        ];
                    case 1:
                        response = _a.sent();
                        // todo what real response?
                        // console.log('unsubscrie', response)
                        delete this.subscriptions[id];
                        return [2 /*return*/];
                }
            });
        });
    };
    Socket.prototype.close = function () {
        this.emit('close');
        if (this.connection)
            this.connection.close();
    };
    return Socket;
}(events_1.EventEmitter));
exports["default"] = Socket;
